import { useState } from "react";
import "./CategoriesShop.css";

const CATEGORIES = [
  "Tất cả",
  "Sản phẩm trải nghiệm",
  "Khăn giấy",
  "Khăn ướt",
  "Tã dán",
  "Tã quần",
  "Combo",
];

const priceRanges = [
  { label: "Dưới 50,000₫", min: 0, max: 50000 },
  { label: "50,000₫ - 100,000₫", min: 50000, max: 100000 },
  { label: "100,000₫ - 200,000₫", min: 100000, max: 200000 },
  { label: "200,000₫ - 500,000₫", min: 200000, max: 500000 },
  { label: "Trên 500,000₫", min: 500000, max: Infinity },
];

// component tạo danh mục tại trang danh sách sản phẩm
const CategoriesShop = (props) => {
  const [active, setActive] = useState("Tất cả");

  const clickHandler = (category) => {
    setActive(category);
    props.onFilter(category);
  };

  return (
    <div className="CS-wrap bg-success">
      <div className=" ms-1">
        <h5 className="text-white mt-2 border-bottom pb-2">
          Danh mục sản phẩm
        </h5>
        <ul className="CS-ul">
          {CATEGORIES.map((category, id) => {
            const activeClasses = category === active ? "greencolor" : "";
            return (
              <li
                key={id}
                className={`CS-li ${activeClasses}`}
                onClick={() => clickHandler(category)}
              >
                {category}
              </li>
            );
          })}
        </ul>
      </div>

      <div className="mt-3 ms-1">
        <h5 className="mb-3 text-white mt-2 border-bottom pb-2">
          Giá sản phẩm
        </h5>

        {priceRanges.map((range, i) => (
          <div key={i} className="mb-1">
            <input
              type="checkbox"
              id={`range-${range.label}`}
              onChange={() => props.onChange(range)}
              className="me-2 text-muted"
            />
            <label htmlFor={`range-${range.label}`}>{range.label}</label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoriesShop;
